import axios from 'axios';
import { XMLParser, XMLValidator } from 'fast-xml-parser/src/fxp';

const api = axios.create();

// import axiosRetry from 'axios-retry';
// axiosRetry(api, {
//   retryDelay: retryCount => retryCount * 1000
// });

api.interceptors.request.use(
  request => {
    request.startTime = Date.now();
    return request;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => {
    if (response && response.config.startTime) {
      response.duration = Number(Date.now() - response.config.startTime);
    }

    if (response && response.data) {
      const isWolframAlphaResponse =
        typeof response.data === 'string' ? response.data.includes('queryresult') : false;

      const options = {
        attributeNamePrefix: 'attr_',
        ignoreAttributes: !isWolframAlphaResponse,
        parseAttributeValue: true
      };

      const parser = new XMLParser();

      return XMLValidator.validate(response.data.toString(), {
        allowBooleanAttributes: true
      }) === true
        ? parser.parse(response.data, options)
        : response.data;
    }

    return response;
  },
  error => Promise.reject(error)
);

export const setBaseURL = baseURL => {
  api.defaults.baseURL = baseURL;
};

class Endpoints {
  paths = {
    getTopFaqs: '/flexAnsWS/ifaqservice.asmx/GetTopFAQs',
    getTopFAQsLanguage: '/flexAnsWS/ifaqservice.asmx/GetTopFAQsLanguage',
    getTopFAQsHotTopicsbyCategory: '/flexAnsWS/ifaqservice.asmx/GetTopFAQsHotTopicsbyCategory',
    getSuggestedQuestions: '/flexAnsWS/ifaqservice.asmx/GetSuggestedQuestions',
    getSuggestedQuestionsbyCategory:
      '/flexAnsWS/ifaqservice.asmx/GetSuggestedQuestionsbyCategoryOptions',
    logger: '/flexansapi/sabio/InsertLogs',
    startSession: '/flexAnsWS/ifaqservice.asmx/StartSessionNew',
    startLanguageSession: '/flexAnsWS/ifaqservice.asmx/StartLanguageSession',
    updateSessionsHistory: '/flexAnsWS/ifaqservice.asmx/UpdateSessionsHistory',
    getMqa: '/flexAnsWS/ifaqservice.asmx/GetMQA',
    getMqaLanguage: '/flexAnsWS/ifaqservice.asmx/GetMQALanguage',
    getMqaLanguageCarousel: '/flexAnsWS/ifaqservice.asmx/GetMQALanguageCarousel',
    getGpfId: '/flexAnsWS/ifaqservice.asmx/GetGPFId',
    getGpfTree: '/flexAnsWS/ifaqservice.asmx/GetGPFTree',
    askWsLanguage: '/flexAnsWS/ifaqservice.asmx/AskWSLanguageCrossSearch',
    askWSLanguagebyCategory: 'flexAnsWS/ifaqservice.asmx/AskWSLanguagebyCategory',
    processFeedback: '/flexAnsWS/ifaqservice.asmx/ProcessFeedback',
    processCrossProject: '/flexAnsWS/ifaqservice.asmx/ProcessCrossProject',
    recordCrossAgencyQuery: '/flexAnsWS/ifaqservice.asmx/RecordCrossAgencyQuery',
    recordSessionEvent: '/flexansapi/Sabio/RecordSessionEvent',
    insertVAInputs: 'flexAnsWS/ifaqservice.asmx/InsertVAInputs',
    wolframAlpha: 'https://ifaqs.flexanswer.com/FlexWS/ifaqservice.asmx/GetDataWA?Query='
  };

  override(paths = {}) {
    this.paths = { ...paths };
  }
}

export const endpoints = new Endpoints();
export const getBaseURL = () => api.defaults.baseURL;

export default api;
